import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from '@usas/ui-web/wrappers/ReactRouterDom';

import NavLinks from '../NavLinks';

import validate from '../components/forms/PreCompLocationFacilityContactFormValidation';

import usePreCompLocationData from '../../../state/preCompLocation/UsePreCompLocationData';
import useTeamFacilityLinksData from '@usas/ui-web/state/teamFacilityLinks/UseTeamsFacilityLinksData';
import useForm from '@usas/ui-web/utils/UseForm';
import Constants from '@usas/ui-web/utils/Constants';

const usePreCompFacilitiesDetail = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [state, setState] = useState({
    tryRedirect: false, isFacilityInClubObj: false, facilityId: Constants.DEFAULT_ID, isNewFacility: false
  });
  const { preCompLocationState } = usePreCompLocationData();
  const { teamFacilityLinksState, putTeamFacilityLinks, getTeamFacilityLinks } = useTeamFacilityLinksData();

  const {
    formState,
    errorState,
    setFormState,
    handleSubmit,
    updateFormState,
    isSubmitting
  } = useForm(getInitialFormState, submitFormCallback, validate);

  function submitFormCallback(formState) {
    if (preCompLocationState.isSaving === false) {
      putTeamFacilityLinks(preCompLocationState.objData.orgUnitId, formState.orgUnitFacilityId, constructOrgUnitObjectForUpdate());

      setState({ ...state, tryRedirect: true });
    }
  };

  function constructOrgUnitObjectForUpdate() {
    let obj = {
      orgUnitFacilityId: formState.orgUnitFacilityId,
      orgUnitId: formState.orgUnitId,
      facilityId: formState.facilityId,
      effectiveDate: null,
      expirationDate: null,
      facility: undefined,
      clubFacilityContactName: formState.clubFacilityContactName.trim(),
      clubFacilityContactEmailAddress: formState.clubFacilityContactEmailAddress.trim(),
      clubFacilityContactPhoneNumber: formState.clubFacilityContactPhoneNumber?.trim(),
      facilityContactName: formState.contactName.trim(),
      facilityContactEmailAddress: formState.contactEmailAddress.trim(),
      facilityContactPhoneNumber: formState.contactPhoneNumber?.trim(),
      trainingFacility: formState.trainingFacility
    };

    return obj;
  };

  const onCancelClicked = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    navigate(NavLinks.PRE_COMP_LOCATION_FACILITY);
  };

  useEffect(() => {
    if (location.state && location.state.facilityId && location.state.isNewFacility === true) {
      getTeamFacilityLinks(preCompLocationState.objData.orgUnitId);
      setState({ ...state, isFacilityInClubObj: true, facilityId: location.state.facilityId, isNewFacility: true });
    }
    else if (location.state && location.state.facilityId && location.state.isNewFacility === undefined) {
      setState({ ...state, isFacilityInClubObj: true, facilityId: location.state.facilityId, isNewFacility: false });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (teamFacilityLinksState.isArrayLoaded === true && teamFacilityLinksState.isSaving === false) {
      if (state.isFacilityInClubObj === true && state.facilityId > 0) {
        const selectedFacility = teamFacilityLinksState.arrayData.find((facility) =>
          facility.facilityId === state.facilityId);

        setFormState({
          ...formState,
          facilityId: selectedFacility.facilityId || Constants.DEFAULT_ID,
          facilityName: selectedFacility.facility.facilityName || '',
          address1: selectedFacility.facility.address1 || '',
          address2: selectedFacility.facility.address2 || '',
          city: selectedFacility.facility.city || '',
          stateCode: selectedFacility.facility.stateCode || '',
          postalCode: selectedFacility.facility.postalCode || '',
          contactName: selectedFacility.facility.contactName || '',
          contactEmailAddress: selectedFacility.facility.contactEmailAddress || '',
          contactPhoneNumber: selectedFacility.facility.contactPhoneNumber || '',
          clubFacilityContactName: selectedFacility.clubFacilityContactName || '',
          clubFacilityContactEmailAddress: selectedFacility.clubFacilityContactEmailAddress || '',
          clubFacilityContactPhoneNumber: selectedFacility.clubFacilityContactPhoneNumber || '',
          orgUnitFacilityId: selectedFacility.orgUnitFacilityId || Constants.DEFAULT_ID,
          orgUnitId: selectedFacility.orgUnitId || '',
          trainingFacility: selectedFacility.trainingFacility !== undefined && selectedFacility.trainingFacility !== null ? selectedFacility.trainingFacility : ''
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [teamFacilityLinksState, state]);

  useEffect(() => {
    if (teamFacilityLinksState.isArrayLoaded === true && teamFacilityLinksState.isSaving === false && state.tryRedirect === true
      && isSubmitting === false && Object.keys(errorState).length === 0) {
      if (state.isNewFacility === true) {
        navigate(NavLinks.PRE_COMP_LOCATION_FACILITY_POOL_DETAIL, { state: { facilityId: state.facilityId } });
      }
      else if (state.isNewFacility === false) {
        navigate(NavLinks.PRE_COMP_LOCATION_FACILITY, { state: { hasNewFacilityDetails: true } });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [teamFacilityLinksState, state, isSubmitting, errorState]);

  function getInitialFormState() {
    return {
      facilityId: Constants.DEFAULT_ID,
      facilityName: '',
      address1: '',
      address2: '',
      city: '',
      stateCode: '',
      postalCode: '',
      contactName: '',
      contactEmailAddress: '',
      contactPhoneNumber: '',
      clubFacilityContactName: '',
      clubFacilityContactEmailAddress: '',
      clubFacilityContactPhoneNumber: '',
      trainingFacility: ''
    };
  }

  return {
    teamFacilityLinksState,
    formState,
    errorState,
    handleSubmit,
    onFormValueChanged: updateFormState,
    onCancelClicked
  };
};

export default usePreCompFacilitiesDetail;